import { render, staticRenderFns } from "./admin-users-add.vue?vue&type=template&id=6ab3a6ee&"
import script from "./admin-users-add.vue?vue&type=script&lang=js&"
export * from "./admin-users-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports